<template>
  <div class="text-white py-6">
    <!-- Header Section -->
    <section class="py-6">
      <UPageHero
        :title="heroTitle"
        :description="heroDescription"
        class="py-0!"
        :ui="{
          container: '!py-4 !px-0',
        }"
      />
    </section>

    <!-- features -->
    <section
      v-for="(feature, index) in features"
      :key="index"
      class="py-6"
    >
      <UPageSection
        :title="feature.featuresTitle"
        :description="feature.featuresDescription"
        :features="feature.featuresNodes"
        :ui="{
          container: '!py-4 !px-0',
          features: 'sm:grid-cols-2 lg:grid-cols-3 gap-8',
        }"
      />
    </section>

    <!-- How It Works Section -->
    <section class="py-6">
      <UPageSection
        :title="howItWorksTitle"
        :description="howItWorksDescription"
        :ui="{
          container: '!py-4 !px-0',
        }"
      >
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <UPageCard
            v-for="step in steps"
            :key="step.number"
            :title="step.title"
            :description="step.description"
            icon="i-simple-icons-tailwindcss"
            variant="soft"
          >
          </UPageCard>
        </div>
      </UPageSection>
    </section>

    <!-- FAQ Section -->
    <section class="py-6">
      <UPageSection
        title="FAQ"
        :description="faqsTitle"
        :ui="{
          container: '!py-4 !px-0',
        }"
      >
        <UAccordion
          :items="faqs"
          :default-value="['0']"
          :ui="{
            trigger: 'text-[14px]',
            body: 'text-[14px] text-muted',
          }"
        />
      </UPageSection>
    </section>

    <!-- Call to Action Button -->
    <section class="py-6">
      <UPageCTA
        :title="ctaTitle"
        :description="ctaDescription"
        variant="solid"
        class="bg-[#7c3aed] text-white"
        :ui="{
          root: 'text-white',
          container: '!py-12',
          title: 'text-white',
          description: 'text-white',
        }"
      >
        <template #links>
          <UButton
            :label="ctaButtonText"
            color="neutral"
            size="lg"
            leading-icon="i-lucide-sparkles"
            @click="scrollToTop"
          />
        </template>
      </UPageCTA>
    </section>
  </div>
</template>

<script setup>
import { inject } from "vue";

// 定义 props
const props = defineProps({
  // Hero Section
  heroTitle: {
    type: String,
    required: true,
  },
  heroDescription: {
    type: String,
    required: true,
  },

  // Features Section
  features: {
    type: Array,
    required: true,
  },

  // How It Works Section
  howItWorksTitle: {
    type: String,
    default: "How It Works",
  },
  howItWorksDescription: {
    type: String,
    required: true,
  },
  steps: {
    type: Array,
    required: true,
  },

  // FAQ Section
  faqsTitle: {
    type: String,
    required: true,
  },
  faqs: {
    type: Array,
    required: true,
  },

  // CTA Section
  ctaTitle: {
    type: String,
    required: true,
  },
  ctaDescription: {
    type: String,
    required: true,
  },
  ctaButtonText: {
    type: String,
    default: "Start Generating Now",
  },
});

// 从父组件注入 scrollToTop 函数
const scrollToTop = inject("scrollToTop", () => {
  console.warn("scrollToTop function not provided");
});
</script>
